<template>
  <section class="title-content">
    <div class="logo pic-full"></div>
    <div class="title-container">
      <p class="title">{{ $t('title') }}</p>
      <p class="subtitle">{{ $t('subtitle') }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "title-content"
}
</script>

<style lang="less">
@media screen and (min-width: 1000px) {
  .title-container .title {
    margin-left: 44px;
  }
}
@media screen and (max-width: 1000px) and (min-width: 767px) {
  .title-container .title {
    margin-left: 29px;
  }
}
@media screen and (min-width: 767px) {
  .logo {
    width: 0.8rem;
    height: 0.8rem;
    background-image: url("../assets/img/pc/discover.png");
    position: absolute;
    left: 0;
    right: 0;
    margin: -0.12rem auto auto;
  }
  .title-container {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;

    .title, .subtitle {
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
    }
    .title {
      width: 2.68rem;
    }
    .subtitle {
      margin-right: 70px;
    }
  }
}

@media screen and (max-width: 767px) {
  .logo {
    width: 1.47rem;
    height: 1.47rem;
    background-image: url("../assets/img/mobile/discover.png");
    margin: 0 auto;
  }
  .title-container {
    margin: 0.59rem auto 0;

    .title, .subtitle {
      font-family: PingFangSC, PingFangSC-Medium;
    }
    .title {
      font-size: 0.88rem;
      font-weight: 500;
      margin: 0.59rem auto 0;
      width: 6.86rem;
    }
    .subtitle {
      width: 6.86rem;
      font-weight: 400;
      margin: 0.38rem auto 0;
      font-size: 0.56rem;
    }
  }
}
</style>
